import React from "react";
import { renderSuperscriptDagger } from "../../helpers/TextFormatting";

/**
 * Renders a single specification table row
 */
const SpecificationRow = ({ index, label, values, unit, activeTabId }) => {
  if (!values || values.length === 0) {
    return null;
  }

  const cleanedLabel = String(label ?? "").replace(/\W/g, '').toLowerCase();

  return (
    <tr className="product-spec__table--row" key={`${activeTabId}-${label}-${values.join("_")}-${index}`}>
      <th id={cleanedLabel} className="product-spec__table-label bold-bold" scope="row">
        <div className="product-spec__table-cell--line">{renderSuperscriptDagger(label, `${cleanedLabel}-label`)}</div>
      </th>
      <td className="bold-semi-bold" headers={cleanedLabel}>
        {values.map((item, idx) => (
          <div className="product-spec__table-cell--line" key={`${idx}-${item}`}>
            {renderSuperscriptDagger(item, `${cleanedLabel}-value-${idx}`)} {renderSuperscriptDagger(unit, `${cleanedLabel}-unit-${idx}`)}
          </div>
        ))}
      </td>
    </tr>
  );
};

export default SpecificationRow;
